import React from 'react'
import { number } from 'prop-types'
import typography from '../../utils/typography'

import ContentSection from '../ContentSection'

import { GridWrapper, GridItem } from './components/Grid'
import { Promo } from './components/Promo'
import { Additional } from './components/Additional'
import { BrandGrid } from './components/BrandGrid'
import { Wrapper, WrapperInner } from './components/Wrapper'

const PrimaryActions = ({ count }) => {
  return (
    <ContentSection bg="#EEF4F9" pb={[0, null, typography.rhythm(1)]}>
      <Wrapper>
        <WrapperInner>
          <GridWrapper>
            <GridItem>
              <Promo
                title="Book Service or MOT"
                alt
                src="/image/primary-action-1.png"
                to="/servicing"
              />
            </GridItem>
            <GridItem>
              <Promo
                title="Explore New Cars"
                alt
                src="/image/primary-action-2.png"
                to="/cars/new"
              />
            </GridItem>
            <GridItem>
              <Promo
                title="Search Used Cars"
                {...(count && { description: `(${count})` })}
                src="/image/primary-action-3.png"
                to="/cars/used"
              />
            </GridItem>
          </GridWrapper>

          <Additional />

          <BrandGrid />
        </WrapperInner>
      </Wrapper>
    </ContentSection>
  )
}

PrimaryActions.propTypes = {
  count: number
}

export default PrimaryActions
